import SecondaryPageLayout from '@/Layout/SecondaryPageLayout';
import SubmitArrowButtonIcon from '@/components/Button/SubmitArrowButtonIcon';
import useEnableMfa from '@/hooks/use-enable-mfa';
import useSkipMfa from '@/hooks/use-skip-mfa';
import Button from '@/shared/components/Button';

const MfaOnboarding = () => {
  const skipMfa = useSkipMfa();
  const enableMfa = useEnableMfa();

  return (
    <SecondaryPageLayout
      isHeaderCentered
      title="mfa.onboarding"
      description="mfa.onboarding_description"
      onSkip={skipMfa}
    >
      <Button
        type="primary"
        title="mfa.enable_mfa"
        icon={<SubmitArrowButtonIcon />}
        iconPlacement="edge"
        onClick={enableMfa}
      />
    </SecondaryPageLayout>
  );
};

export default MfaOnboarding;
